import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import moment from 'moment';
import 'moment/locale/fr';

// Import all EN locale files
import commonEn from './locales/en/common.json';
import menuEn from './locales/en/menu.json';
import ordersEn from './locales/en/orders.json';
import routesEn from './locales/en/routes.json';
import partnersEn from './locales/en/partners.json';
import driversEn from './locales/en/drivers.json';
import fleetEn from './locales/en/fleet.json';
import hubsEn from './locales/en/hubs.json';
import schedulerEn from './locales/en/scheduler.json';
import statsEn from './locales/en/stats.json';
import authEn from './locales/en/auth.json';

// Import all FR locale files
import commonFr from './locales/fr/common.json';
import menuFr from './locales/fr/menu.json';
import ordersFr from './locales/fr/orders.json';
import routesFr from './locales/fr/routes.json';
import partnersFr from './locales/fr/partners.json';
import driversFr from './locales/fr/drivers.json';
import fleetFr from './locales/fr/fleet.json';
import hubsFr from './locales/fr/hubs.json';
import schedulerFr from './locales/fr/scheduler.json';
import statsFr from './locales/fr/stats.json';
import authFr from './locales/fr/auth.json';

const savedLanguage = localStorage.getItem('ovo-language') || 'en';

i18n.use(initReactI18next).init({
  resources: {
    en: {
      common: commonEn,
      menu: menuEn,
      orders: ordersEn,
      routes: routesEn,
      partners: partnersEn,
      drivers: driversEn,
      fleet: fleetEn,
      hubs: hubsEn,
      scheduler: schedulerEn,
      stats: statsEn,
      auth: authEn,
    },
    fr: {
      common: commonFr,
      menu: menuFr,
      orders: ordersFr,
      routes: routesFr,
      partners: partnersFr,
      drivers: driversFr,
      fleet: fleetFr,
      hubs: hubsFr,
      scheduler: schedulerFr,
      stats: statsFr,
      auth: authFr,
    },
  },
  lng: savedLanguage,
  fallbackLng: 'en',
  defaultNS: 'common',
  interpolation: { escapeValue: false },
});

moment.locale(savedLanguage);
i18n.on('languageChanged', (lng) => {
  moment.locale(lng);
  localStorage.setItem('ovo-language', lng);
});

export default i18n;
